import NormalizeStyles from './styles/NormalizedStyles';
import BaseStyles from './styles/BaseStyles';
import './styles/fontStyles.css';

import { SnackbarProvider } from 'notistack';
import { PropTypes } from 'prop-types';

const BaseApp = ({ children }) => {
  return (
    <div>
      <SnackbarProvider
        maxSnack={3}
        preventDuplicate={true}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <NormalizeStyles />
        <BaseStyles />
        {children}
      </SnackbarProvider>
    </div>
  );
};

BaseApp.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default BaseApp;
